<span class="material-icons-outlined file-add"
      (click)="this.openUploadDialog(-1)"
      matTooltipPosition="above"
      matTooltip="Upload Files...">
    library_add
</span>

